import React, { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";

const AdminRoute = memo(function AdminRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);

  useEffect(() => {
    if (session.status === "unauthorized") {
      navigate("/admin/signin");
      return;
    }
    if (session.status === "authorized" && session?.user?.roleCode === "user") {
      navigate("/");
      return;
    } else if (session?.status === "authorized" && session?.user?.roleCode === "donor") {
      navigate("/donor/donation");
    }
  }, [session.status, navigate, session?.user?.roleCode]);

  if (session.status === "loading") {
    return <LoadingFallback />;
  }

  return session.status === "authorized" && session?.user?.roleCode === "admin" ? children : null;
});

export default AdminRoute;
